/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { useEffect, useState } from "react";
import { Grid, makeStyles, IconButton, Typography, Tooltip, Button, Dialog, Slide, AppBar, Toolbar} from "@material-ui/core";
import { Edit, Delete, Lock, Person, AddCircleOutline, CloseOutlined} from "@material-ui/icons";
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCog } from "@fortawesome/pro-solid-svg-icons";
import { dateFormat } from "../utils";
import EditRole from "./EditRole";
import MuiDialog from "../Dialog";
import Actions from "../../../fluid/Actions/ActionFactory";
import SnackBar from "../../Snackbar/index";
import ErrorMessageAlert from "../../Utilities/ErrorMessageAlert";
import PolicyEditor from "../PolicyEditor/PolicyEditor_new";
import SecureWrapper from "../../Security/SecureWrapper";
import { allowedByOpop } from '../../Security/SecureCheck';

const blue_theme = createTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc014e",
    },
  },
});

const useStyles = makeStyles(() => ({
  container: {
    // display: "flex",
    // flexDirection: "column",
    // border: "1px solid black",
    height: "340px",
  },
  headerSec: {
    width: "100%",
    height: "100%",
    padding: "10px",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ViewRole = ({
  selectedData,
  isTableUpdated,
  setIsTableUpdated,
  setdeleted,
}) => {
  const classes = useStyles();
  console.log("roles child", selectedData);
  const data = selectedData;
  const [isRoleDelete, setIsRoleDelete] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [isEditRole, setIsEditRole] = useState(false);
  const [isViewEnable, setIsViewEnable] = useState(true);
  const [isEdited, setisEdited] = useState(false);
  const [error, seterror] = useState(false);
  const [errmsg, seterrmsg] = useState(null);
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    setIsEditRole(false);
  }, [selectedData]);
  useEffect(() => {
    if (!!data && isDeleted) {
      // console.log("count...");
      Actions("http_request", {
        url: "/sainapse/role/" + data.name + "/group/" + data.group_name  ,
        method: "delete",
        // data: data,
      })
        .then((res) => {
          console.log("res..1", res.data);
          setIsDeleted(!isDeleted);
          setIsTableUpdated(true);
          setIsViewEnable(false);
          setdeleted(true);
        })
        .catch((err) => {
          console.log("err..", err.message);
          seterror(true);
          seterrmsg(err);
        });
    }
  }, [isDeleted]);

  const handleDeleteRole = () => {
    setIsRoleDelete(true);
  };
  const handleEditRole = () => {
    setIsEditRole(true);
  };
  const onClose = () => {
    setisEdited(false);
  };
  const onCloseerror = () => {
    seterror(false);
    seterrmsg(null);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getEditDisableStatus = (roleName, groupName) => {
    
    return !allowedByOpop({
      operation : "/sainapse/role/{name}/group/{group_name}",
      method : "PUT",
      operands : [
        {
          attrName: "name",
          value : roleName
        },
        {
          attrName: "group_name",
          value :  groupName
        }]
    })
  };

  const getDeleteDisableStatus = (roleName, groupName) => {
    
    return !allowedByOpop({
      operation : "/sainapse/role/{name}/group/{group_name}",
      method : "DELETE",
      operands : [
        {
          attrName: "name",
          value : roleName
        },
        {
          attrName: "group_name",
          value :  groupName
        }]
    })
  };
  return (
    <>
    <ThemeProvider theme = {blue_theme}>
    <div style={{ maxWidth: "100%", display: "flex", flexDirection: "column" }}></div>
      {isEditRole ? (
        <EditRole
          prevData={data}
          setIsEditRole={setIsEditRole}
          setisEdited={setisEdited}
          setIsTableUpdated={setIsTableUpdated}
        />
      ) : isViewEnable ? (
        <Grid container className={classes.container}>
          <Grid item className={classes.headerSec}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                // padding: "10px",
                height: "30%",
                // border: "1px solid black",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", width : '100%' }}>
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    // background: "#00000029",
                    borderRadius: "5px",
                    marginRight: "10px",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faUserCog}
                    style={{
                      width: "100%",
                      height: "100%",
                      color: "#00000059",
                    }}
                  />
                </div>
                <div
                  style = {{display : 'flex', flexDirection : 'row', alignItems : 'flex-end', flexGrow : 1}}
                >
                    <Typography variant = 'body2' color = 'textSecondary'>{data.group_name + " / "}</Typography>
                    <Typography style = {{marginLeft : '3px'}} variant = 'subtitle2' color = 'textPrimary'>{data?.name ? " " + data.name : "-"}</Typography>
                </div>
                <div
                  style = {{
                    display : 'flex',
                    flexDirection : 'row',
                    alignItems : 'center'
                  }}
                >
                  <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/policy",
                        method : "GET",
                        operands : []
                      }}
                    > 
                    <Button
                      style = {{marginRight : '5px'}}
                      variant = 'contained'
                      size = 'small'
                      color = 'primary'
                      startIcon={<AddCircleOutline />}
                      onClick={handleClickOpen}
                    >
                      Policy
                    </Button>
                 </SecureWrapper>
                <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/role/{name}/group/{group_name}",
                        method : "PUT",
                        operands : [
                          {
                            attrName: "name",
                            value : data.name
                          },
                          {
                            attrName: "group_name",
                            value :  data.group_name
                          }]
                      }}
                    >
                  <Tooltip title = "Edit">
                    <IconButton
                      style = {{marginRight : '5px'}}
                      fontSize="small"
                      color = 'primary'
                      // style={{
                      //   display: "block",
                      //   color: "#3683F7",
                      //   cursor: "pointer",
                      //   width: "33.3%",
                      //   marginRight: "-35px",
                      //   background: "none",
                      // }}
                      // disableRipple={true}
                      onClick={handleEditRole}
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                </SecureWrapper>
                <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/role/{name}/group/{group_name}",
                        method : "DELETE",
                        operands : [
                          {
                            attrName: "name",
                            value : data.name
                          },
                          {
                            attrName: "group_name",
                            value :  data.group_name
                          }]
                      }}
                    >
                  <Tooltip title = "Delete">
                    <IconButton
                      color = 'secondary'
                      style={{ color: "#f44336", marginRight: "5px" }}
                      fontSize="small"
                      // style={{
                      //   display: "block",
                      //   color: "#FF0000",
                      //   cursor: "pointer",
                      //   width: "33.3%",
                      //   background: "none",
                      // }}
                      // disableRipple={true}
                      onClick={handleDeleteRole}
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                </SecureWrapper>
                </div>
              </div>
            </div>
            <div
              style={{
                boxShadow: "0px 3px 6px #00000029",
                bordeRadius: "5px",
                height: "70%",
                // border: "1px solid black",
              }}
            >
              <div
                style={{
                  background: "#FFFFFF",
                  borderBottom: "1px solid #00000029",
                  padding: "20px",
                  color: "#707070",
                  height: "70%",
                }}
              >
                <p>{data?.description ? data.description : "No Description"}</p>
              </div>
              <div
                style={{
                  display: "flex",
                  background: "#FFFFFF",
                  padding: "20px",
                  height: "30%",
                }}
              >
                <div style={{ paddingRight: "60px" }}>
                  <p style={{ color: "#707070" }}>
                    Active Since <br />{" "}
                    <span style={{ color: "#3682F7" }}>
                      {dateFormat(data?.created_date)}
                    </span>
                  </p>
                </div>
                <div>
                  <p style={{ color: "#707070" }}>
                    Last Updated <br />
                    <span style={{ color: "#3682F7" }}>
                      {dateFormat(data?.updated_date)}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </Grid>
          {/* <Dialog
            fullScreen
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
          >
            <AppBar sx={{ position: 'relative' }}>
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={handleClose}
                  aria-label="close"
                >
                  <CloseOutlined />
                </IconButton>
              </Toolbar>
            </AppBar>
            
          </Dialog>  */}
          {open && <PolicyEditor open={open} roleData={data}  onClose = {handleClose}></PolicyEditor>}
          {isRoleDelete && (
            <MuiDialog
              menu="roles"
              data={data}
              open={isRoleDelete}
              type="delete"
              title="Delete Role"
              onClose={setIsRoleDelete}
              onSuccess={setIsDeleted}
            />
          )}
        </Grid>
      ) : null}
      {isEdited && (
        <SnackBar
          openDialog={isEdited}
          message={"Role has been Updated successfully"}
          onclose={onClose}
          severity={"success"}
        />
      )}
      {error && (
        <ErrorMessageAlert
          open={error}
          handleClose={onCloseerror}
          errorInfo={errmsg}
        />
      )}
      </ThemeProvider>
    </>
  );
};

export default ViewRole;
